import { render, staticRenderFns } from "./Link-sales.vue?vue&type=template&id=3da501e8"
import script from "./Link-sales.vue?vue&type=script&lang=js"
export * from "./Link-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports